export default class Helper {
    static isInsideEditor() {
        return document.querySelector('.editor') !== null;
    }

    static fixWshSvgs() {
        /* fix wsh svgs (see: https://stackoverflow.com/questions/15911717/clippath-in-multiple-svg-tags) */
        if (document.querySelector('[id^="cut-off-bottom"]') !== null) {
            document.querySelectorAll('[id^="cut-off-bottom"]').forEach((el, i) => {
                el.setAttribute('id', 'cut-off-bottom-' + i);
            });
        }
        if (document.querySelector('[clip-path^="url(#cut-off-bottom"]') !== null) {
            document.querySelectorAll('[clip-path^="url(#cut-off-bottom"]').forEach((el, i) => {
                el.setAttribute('clip-path', 'url(#cut-off-bottom-' + i + ')');
            });
        }
    }
}
